import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HolidaySessionsDialog, HolidaySessionsInfo } from "@/components/psychologist/calendar/HolidaySessionsDialog";
import { sessionsOnHoliday } from "@/pages/psychologist/tabs/comunidad/holidaySessions";
import { useToast } from "@/hooks/useToast";
import { activityTracker } from "@/utils/activityTracker";

/**
 * "Bloquear mi agenda" para un feriado, igual en el aviso de la Agenda y en la marca del
 * feriado de cada día: si ese día tiene sesiones, muestra "Tenés sesiones agendadas ese día"
 * (con el paso a paso) y no deja bloquear; si no, abre el panel de bloqueo con el feriado
 * cargado. `dialog` se renderiza donde se use el hook.
 */
export function useBlockHoliday(timezone: string) {
  const navigate = useNavigate();
  const { showWarning } = useToast();
  const [checking, setChecking] = useState<string | null>(null);
  const [sessionsInfo, setSessionsInfo] = useState<HolidaySessionsInfo | null>(null);

  const bloquear = async (date: string, name: string) => {
    if (checking) return;
    // Métricas de Actividad: tocó "Bloquear mi agenda" para un feriado.
    activityTracker.trackAction("feriado_bloquear");
    setChecking(date);
    try {
      const sessions = await sessionsOnHoliday(date, timezone);
      if (sessions.length > 0) {
        setSessionsInfo({ date, name, sessions });
        activityTracker.trackAction("feriado_sesiones_vistas");
        return;
      }
      navigate(`/calendar?${new URLSearchParams({ config: "block", date, reason: `Feriado: ${name}` })}`);
    } catch {
      showWarning("No pudimos revisar tu agenda de ese día. Probá de nuevo en un rato.");
    } finally {
      setChecking(null);
    }
  };

  const dialog = <HolidaySessionsDialog info={sessionsInfo} timezone={timezone} onClose={() => setSessionsInfo(null)} />;

  return { bloquear, checking, dialog };
}
